import React from "react";
import { Modal } from "antd";
import { IMAGE_BASE_URL } from "../../common/Constants";

const DocumentPreview = ({ title, url, open, close, type }) => {
  const DownloadDocumentFile = async () => {
    fetch(IMAGE_BASE_URL + url)
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `Failed to download: ${response.status} ${response.statusText}`
          );
        }
        return response.blob();
      })
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "document";
        console.log(a);
        a.click();
        URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Error downloading file:", error);
      });
  };

  return (
    <>
      <Modal
        open={open}
        title={title}
        onOk={DownloadDocumentFile}
        onCancel={close}
        centered
        okText={"Download"}
        cancelText={"Close"}
        width={700}
      >
        {type == "Image" ? (
          <div className="flex items-center justify-center mb-[20px]">
            <img
              src={IMAGE_BASE_URL + url}
              alt="Your Image"
              className="max-w-full max-h-[300px]"
            />
          </div>
        ) : (
          <div className="flex items-center justify-center mb-[20px]">
            <iframe
              src={IMAGE_BASE_URL + url}
              id="pdf"
              title="PDF Viewer"
              width="100%"
              height="500px"
            />
          </div>
        )}
      </Modal>
    </>
  );
};

export default DocumentPreview;
